// extracted by mini-css-extract-plugin
module.exports = {"strip":"styles_strip__0w_0w","text":"styles_text__75RDs"};